//v1/email/confirm?ApiKey=sdsdf
function ConfirmEmailSvc($resource) {
  'ngInject';
  var odataUrl = TFL_Base_Url + 'email/confirm'
  return $resource(odataUrl, {}, {
      get: { method: 'GET', params: { Email: '@Email', MemberId: '@MemberId' }, isArray: false }
  });
};

export default {
  name: "ConfirmEmailSvc",
  fn: ConfirmEmailSvc
}